import script from "./FooterComp.vue?vue&type=script&lang=ts&setup=true"
export * from "./FooterComp.vue?vue&type=script&lang=ts&setup=true"

import "./FooterComp.vue?vue&type=style&index=0&id=cfca63f4&scoped=true&lang=scss"
import "./FooterComp.vue?vue&type=style&index=1&id=cfca63f4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cfca63f4"]])

export default __exports__